module.exports = __webpack_public_path__ + "img/edge.93fb97da.svg";